/**
 * Mounts a React tree inside a Shadow DOM attached to the given host element.
 * Copies Smartie frontend CSS <link> tags (enqueued by WP) into the shadow root
 * so components render with the correct styles without relying on page styles.
 */
export function mountInShadowRoot(
  host: HTMLElement,
  renderInto: (container: Element) => void,
): void {
  const shadowRoot = host.shadowRoot || host.attachShadow({ mode: "open" });

  // Copy our enqueued CSS links (handles start with 'smartie-ai-style-')
  // WordPress renders them as <link id="{handle}-css" ...>
  const pageLinks = Array.from(
    document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]'),
  );

  for (const link of pageLinks) {
    const id = link.getAttribute("id") || "";
    const href = link.getAttribute("href") || "";
    // Heuristics: copy plugin styles only
    if (
      id.startsWith("smartie-ai-style-") ||
      href.includes("/smartie-wp-plugin/frontend-assets/")
    ) {
      // Avoid duplicating if already cloned
      const already = Array.from(shadowRoot.querySelectorAll("link")).some(
        (l) => (l as HTMLLinkElement).href === link.href,
      );
      if (!already) {
        const clone = link.cloneNode(true) as HTMLLinkElement;
        shadowRoot.appendChild(clone);
      }
    }
  }

  // Create a container inside the shadow root and let caller render into it
  let container = shadowRoot.getElementById("smartie-shadow-app");
  if (!container) {
    container = document.createElement("div");
    container.id = "smartie-shadow-app";
    shadowRoot.appendChild(container);
  }

  renderInto(container);
}


